import { render, staticRenderFns } from "./DeviceSettingKindList.vue?vue&type=template&id=09272798&scoped=true&"
import script from "./DeviceSettingKindList.vue?vue&type=script&lang=ts&"
export * from "./DeviceSettingKindList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09272798",
  null
  
)

export default component.exports